import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Image,
  StyleProp,
  ViewStyle,
} from "react-native";
import { colors } from "src/assets";
import { Badge } from "src/components";
import LocalText from "src/local";

export type TalkActionsProps = {
  containerStyle?: StyleProp<ViewStyle>;
  isMicEnable: boolean;
  isSpeakerEnable: boolean;
  isCameraEnable: boolean;
  isNewMessageIndicator?: boolean;
  isCameraConntected: boolean;
  isFlipEnabled?: boolean;
  onToggleMic?: () => void;
  onToggleSpeaker?: () => void;
  onChat: () => void;
  onToggleCamera?: () => void;
  onMicTurnOn?: () => void;
  onMicTurnOff?: () => void;
  onSpeaker?: () => void;
  onPhone?: () => void;
  onCameraTurnOn?: () => void;
  onCameraTurnOff?: () => void;
  onFlipCamera?: () => void;
};

export const TalkActions: React.FC<TalkActionsProps> = ({
  containerStyle,
  isMicEnable,
  isSpeakerEnable,
  isCameraEnable,
  isNewMessageIndicator,
  isCameraConntected,
  isFlipEnabled,
  onToggleMic,
  onToggleSpeaker,
  onChat,
  onToggleCamera,
  onMicTurnOn,
  onMicTurnOff,
  onSpeaker,
  onPhone,
  onCameraTurnOn,
  onCameraTurnOff,
  onFlipCamera,
}) => {
  return (
    <View style={[styles.root, containerStyle]}>
      {isMicEnable ? (
        <TouchableOpacity style={styles.btn} onPress={onMicTurnOff}>
          <Image
            source={require("./assets/mic-on.png")}
            style={{ width: 56, height: 56 }}
          />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.btn} onPress={onMicTurnOn}>
          <Image
            source={require("./assets/mic-off.png")}
            style={{ width: 56, height: 56 }}
          />
        </TouchableOpacity>
      )}

      {/* {isSpeakerEnable ? (
        <TouchableOpacity style={styles.btn} onPress={onPhone}>
          <Image
            source={require("./assets/speaker.png")}
            style={{ width: 56, height: 56 }}
          />
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.btn} onPress={onSpeaker}>
          <Image
            source={require("./assets/phone.png")}
            style={{ width: 56, height: 56 }}
          />
        </TouchableOpacity>
      )} */}

      <TouchableOpacity style={styles.btn} onPress={onChat}>
        <Image
          source={require("./assets/chat.png")}
          style={{ width: 56, height: 56 }}
        />
        {isNewMessageIndicator ? (
          <Badge
            text={LocalText.screens.call.talkActions.new}
            color={colors.chokuGreen}
            containerStyle={styles.newMessageBadge}
          />
        ) : null}
      </TouchableOpacity>
      {isCameraConntected &&
        (isCameraEnable ? (
          <TouchableOpacity style={styles.btn} onPress={onCameraTurnOff}>
            <Image
              source={require("./assets/camera-on.png")}
              style={{ width: 56, height: 56 }}
            />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity style={styles.btn} onPress={onCameraTurnOn}>
            <Image
              source={require("./assets/camera-off.png")}
              style={{ width: 56, height: 56 }}
            />
          </TouchableOpacity>
        ))}
      {isCameraEnable && isFlipEnabled && (
        <TouchableOpacity style={styles.btn} onPress={onFlipCamera}>
          <Image
            source={require("./assets/camera-toggle.png")}
            style={{ width: 56, height: 56 }}
          />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "transparent",
  },
  btn: {},
  newMessageBadge: {
    position: "absolute",
    top: -30,
    left: 5,
  },
});
